export function isAuthenticated() {
    return !!localStorage.getItem('auth_token');
}